.bubble {
  position: relative;
  display: flex;
  justify-content: flex-start;
}

.content {
  padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
}
